module.exports = __webpack_public_path__ + "img/catharina-maria-bugge-l.43330125.jpg";